import React from 'react';
import { Card } from 'react-bootstrap';
import { calculateTotalDuration } from '../utils/timeCalculations';
import { SessionCalendar } from './SessionCalendar';

interface Session {
    id: string;
    startedAt: string;
    endedAt: string | null;
    lastInteraction: string;
    createdAt: string;
    updatedAt: string;
}

interface SessionsListProps {
    sessions: Session[];
}

export const SessionsList: React.FC<SessionsListProps> = ({ sessions }) => {
    const totalDuration = calculateTotalDuration(sessions);

    if (sessions?.length === 0) {
        return (
            <div className="text-center text-white p-5">
                No hay sesiones para mostrar con los filtros seleccionados
            </div>
        );
    }

    return (
        <div>
            <Card className="mb-4 border-secondary">
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="text-start">
                            <h6 className="text-secondary mb-1">Sesiones</h6>
                            <p className="h3 mb-0">{sessions.length}</p>
                        </div>
                        <div>
                            <h6 className="text-secondary text-end mb-1">Tiempo Total de Sesiones</h6>
                            <p className="h3 mb-0 text-end">{totalDuration}</p>
                        </div>
                    </div>
                </Card.Body>
            </Card>

            <SessionCalendar sessions={sessions} />
        </div>
    );
}; 